import { BehaviorSubject } from "rxjs";
var isLoading = new BehaviorSubject(false);
var isAPIServerError = new BehaviorSubject(false);
var checkDrawerOpen = new BehaviorSubject(false);
var isAuthorized = new BehaviorSubject(false);
var salesOrderSearchText = new BehaviorSubject({
    searchText: "",
    orderTab: "",
});
export { isLoading, isAPIServerError, checkDrawerOpen, isAuthorized, salesOrderSearchText };
